(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/iam-postmessage/assets/javascripts/iam-postmessage-utils.js') >= 0) return;  svs.modules.push('/components/accountservices/iam-postmessage/assets/javascripts/iam-postmessage-utils.js');

'use strict';

const {
  logger
} = svs.accountservices.iamPostMessage;

const noopLogger = {
  debug: () => {},
  info: () => {},
  warn: () => {},
  error: () => {}
};
const safeLogger = logger || noopLogger;

const isOriginTrusted = event => {
  const origin = event.origin;
  const currentOrigin = window.location.origin;

  if (origin === currentOrigin) {
    return true;
  }
  try {
    const originUrl = new URL(origin);
    const currentUrl = new URL(currentOrigin);

    const getRootDomain = hostname => {
      const parts = hostname.toLowerCase().split('.');
      return parts.length >= 2 ? parts.slice(-2).join('.') : hostname.toLowerCase();
    };
    const originRoot = getRootDomain(originUrl.hostname);
    const currentRoot = getRootDomain(currentUrl.hostname);

    return originRoot === currentRoot;
  } catch (error) {
    safeLogger.error('Error validating origin:', error);
    return false;
  }
};

const generateRequestId = () => "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));

Object.assign(svs.accountservices.iamPostMessage, {
  isOriginTrusted,
  generateRequestId
});

 })(window);